const auth = JSON.parse(localStorage.getItem("authUser"));
const accessToken = () => {
    return auth?.data?.token || ""
}
export default accessToken
